import { initializeApp } from "firebase/app";
import { getDatabase } from "firebase/database";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getDecriptedEnv } from "../../actions/DataActions";

export let app = null;
export let db = null;
export let auth = null;
export let firestoreInstance = null;

export const setUpFirebase = (keys) => {
  const decripted = getDecriptedEnv(keys);

  const firebaseConfig = {
    apiKey: decripted.f_api_key,
    authDomain: decripted.f_auth_domain,
    projectId: decripted.f_project_id,
    storageBucket: decripted.f_storage_bucket,
    messagingSenderId: decripted.f_message_sender_id,
    appId: decripted.f_app_id,
    measurementId: decripted.f_measure_id,
  };

  app = initializeApp(firebaseConfig);
  db = getDatabase(app);
  firestoreInstance = getFirestore(app);
  auth = getAuth(app);
};
